export { monitoring } from '@algoan/monitoring';

export enum LogAction {
  LOGIN_REDIRECTION = 'LOGIN_REDIRECTION',
  LOGIN_SUCCESS = 'LOGIN_SUCCESS',
  PREPARE_API_REQUEST = 'PREPARE_API_REQUEST',
}
